"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var material_1 = require("@mui/material");
var react_quill_1 = __importDefault(require("react-quill"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var LocalApplicationContext_1 = __importDefault(require("../context/LocalApplicationContext"));
var UserContext_1 = __importDefault(require("../../context/UserContext"));
var PlainMotivation = function (_a) {
    var motivation = _a.motivation;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ padding: 4, sx: {
            borderTop: '1px solid',
            borderColor: 'primary.main',
        } }, { children: (0, html_react_parser_1.default)(motivation || '') })));
};
var EditMotivation = function (_a) {
    var incomingMotivation = _a.motivation, handleUpdate = _a.handleUpdate, handleSend = _a.handleSend;
    var hasCv = (0, react_1.useContext)(UserContext_1.default).hasCv;
    var _b = (0, react_1.useState)(incomingMotivation), motivation = _b[0], setMotivation = _b[1];
    var _c = (0, react_1.useState)(), file = _c[0], setFile = _c[1];
    var handleFileSelected = function (incomingEvent) {
        setFile(incomingEvent.target.files[0]);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ padding: 2, display: "flex", flexDirection: "column", gap: 4, sx: { borderTop: '1px solid', borderColor: 'primary.main' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", fontWeight: "bold" }, { children: trans_1.default.get('columns.application.motivation') })), (0, html_react_parser_1.default)(trans_1.default.get('strings.frontend.application.motivation_tips')), !hasCv && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: trans_1.default.get('strings.frontend.application.accepted_extensions') }) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Button, __assign({ variant: "outlined", startIcon: (0, jsx_runtime_1.jsx)(Add_1.default, {}), component: "label" }, { children: [(0, jsx_runtime_1.jsx)("input", { id: "resume", style: { display: 'none' }, accept: ".doc,.docx,.pdf,.odt,.rtf", onChange: handleFileSelected, type: "file" }), file && file.name ? file.name : "".concat(trans_1.default.get('buttons.general.crud.upload'), " ").concat(trans_1.default.get('columns.profile.resume'))] })) })) })), (0, jsx_runtime_1.jsx)(react_quill_1.default, { theme: "snow", value: motivation, onChange: setMotivation }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", gap: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", onClick: function () { return handleUpdate({ motivation: motivation, file: file }); } }, { children: trans_1.default.get('buttons.frontend.application.save_concept') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", onClick: function () { return handleSend({ motivation: motivation, file: file }); } }, { children: trans_1.default.get('buttons.frontend.application.send') }))] }))] })));
};
function ApplicationMotivation(_a) {
    var handleSend = _a.handleSend, handleUpdate = _a.handleUpdate;
    var currentApplication = (0, react_1.useContext)(LocalApplicationContext_1.default).currentApplication;
    if (!currentApplication) {
        return null;
    }
    return currentApplication.currentStatus.machine_name === 'concept' && currentApplication.isAvailable ? ((0, jsx_runtime_1.jsx)(EditMotivation, { motivation: currentApplication.motivation, handleUpdate: handleUpdate, handleSend: handleSend })) : ((0, jsx_runtime_1.jsx)(PlainMotivation, { motivation: currentApplication.motivation }));
}
exports.default = ApplicationMotivation;
